import { useMemo } from "react";
import { useAuth } from "@/AuthContext";
import { isAgencyUser } from "@/utils/party";

export function useWorkspace() {
  const { user, isLoading } = useAuth();

  return useMemo(() => {
    return {
      isLoading,
      isAgencyMember: isAgencyUser(user),
      agencyId: user?.organization_id || null,
      roles: user?.roles || [],
    };
  }, [user?.organization_id, user?.roles, isLoading]);
}
